module.exports = "/images/tool-file.svg?7f73040a06f8d1e458bc6fa652717b81";